import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Траектории обучения",
  "lead": "Хотя большинство детей сейчас проводят в школе много лет, зачастую они выходят из нее, не имея даже самых элементарных навыков чтения и математики. Траектории обучения показывают, сколько знаний усваивают дети по мере обучения в школе. Они могут помочь нам понять процесс, который приводит к низким результатам обучения, когда и как вмешиваться в этот процесс, а также каким может быть смоделированное воздействие различных политик на насущную проблему низкого уровня обучения."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Explorer, Figure, HighlightByIndex, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollyStep, ScrollySticky, SimulationsTab, TrajectoriesTab} = _components;
  if (!Explorer) _missingMdxReference("Explorer", true);
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollyStep) _missingMdxReference("ScrollyStep", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!SimulationsTab) _missingMdxReference("SimulationsTab", true);
  if (!TrajectoriesTab) _missingMdxReference("TrajectoriesTab", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_LEARNING"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Траектории обучения показывают, сколько лет или классов требуется детям для приобретения базовых навыков. Поскольку эти траектории отслеживают темпы обучения в системе, они могут помочь нам понять, сколько детей борются за приобретение этих навыков, когда и как вмешиваться, а также как различные политики могут повлиять на насущную проблему низкого уровня обучения."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "на-что-указывают-траектории-обучения",
      children: "На что указывают траектории обучения?"
    }), "\n", _jsx(_components.p, {
      children: "В идеале траектории обучения должны быть крутыми. Однако зачастую наблюдаются плоские траектории, что указывает на медленный темп обучения. Медленный старт может иметь долгосрочные последствия. Это происходит потому, что, когда дети отстают, учебная программа часто переходит к более сложному материалу, для освоения которого у них отсутствуют необходимые навыки."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Траектории многих стран указывают на слишком медленные темпы обучения, отмечаемые с самого начала обучения в школе."
      }), " Согласно глобальным целям и многим национальным учебным программам в 1-м и 2-м классах, дети должны читать, но на самом деле это делает лишь незначительное меньшинство детей."]
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1a",
      children: _jsxs(_components.p, {
        children: ["Навыки, оцениваемые в шестом раунде Кластерных обследований по многим показателям (КОМП), являются основными предпосылками для будущего обучения и измеряются по тому, могут ли дети прочитать вслух простой рассказ из 70 слов (например, «Ман учится во втором классе») и ответить на пять простых вопросов по тексту (например, «В каком классе учится Ман?»). Эти базовые навыки, как правило, ниже минимального уровня владения навыками, определенного ", _jsx(_components.a, {
          href: "https://sdgs.un.org/goals/goal4",
          children: "глобальным показателем 4.1.1 a Цели в области устойчивого развития (ЦУР)"
        }), ". Таким образом, рассчитанные траектории переоценивают прогресс в достижении показателя 4.1.1 a ЦУР, но все еще являются полезными оценками для иллюстрации темпов обучения."]
      })
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TRAJECTORIES_CURRENT"
        })
      }), _jsx(ScrollySection, {
        id: "HIGHLIGHT_VIETNAM",
        children: _jsxs(_components.p, {
          children: [_jsx(HighlightByIndex, {
            index: "2",
            children: "Вьетнам"
          }), " является хорошим примером\nотносительно траектории страны с высокими показателями. В начальных классах\nшколы большинство детей во Вьетнаме обучаются базовым навыкам чтения."]
        })
      }), _jsx(ScrollySection, {
        id: "LMIC_GRADE_3",
        children: _jsxs(_components.p, {
          children: ["Траектория обучения во многих других", " ", "\n", _jsx(HighlightByIndex, {
            index: "4",
            children: "странах с низким уровнем доходов и с уровнем доходов ниже среднего"
          }), " ", "\nгораздо более плоская. Только один из четырех детей в среднестатистической стране\nв настоящее время владеет базовыми навыками чтения к 3 классу."]
        })
      }), _jsx(ScrollySection, {
        id: "LMIC_GRADE_6",
        children: _jsxs(_components.p, {
          children: ["Низкий уровень обучения сохраняется по мере того, как дети продолжают учиться в школе. Чуть более половины\nучащихся 6 класса в среднестатистических", " ", "\n", _jsx(HighlightByIndex, {
            index: "4",
            children: "странах с низким уровнем доходов и с уровнем доходов ниже среднего"
          }), " ", "\nв наборе данных продемонстрировала результаты, соответствующие обычному уровню навыков чтения для 2–3\nкласса."]
        })
      }), _jsx(ScrollySection, {
        id: "DIFFERENCE_TRAJECTORIES",
        children: _jsx(_components.p, {
          children: "Однако средняя траектория скрывает различия между странами. В выборке данных\nот 3 до 76 процентов детей в странах с низким уровнем доходов и\nс уровнем доходов ниже среднего умеют читать к третьему классу. Это\nсвидетельствует о том, что страны, которые берут на себя обязательство улучшить базовое обучение, могут\nсделать это даже при относительно низком уровне национального дохода."
        })
      }), _jsx(ScrollyStep, {
        id: "default"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Для страны, которая хочет решить проблему низкого уровня образования, выводы, полученные в результате применения политики, таковы:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Необходимо оценивать и расставлять приоритеты в отношении базовых навыков, начиная с младших классов."
      }), "\n", _jsx(_components.li, {
        children: "Необходимо привести обучение в соответствие с фактическим темпом обучения детей. Это можно сделать разными способами, в том числе путем установления четких целей обучения, ориентированных на базовое обучение, корректировки темпа учебной программы и оказания помощи учителям в понимании и адаптации своего преподавания к текущему уровню обучения детей."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "моделирование-политики-доступ-и-обучение",
      children: "Моделирование политики: доступ и обучение"
    }), "\n", _jsx(_components.p, {
      children: "Мы можем использовать траектории обучения для сравнения потенциального воздействия различных политик. В данном примере мы моделируем влияние политик, направленных на расширение доступа и улучшение качества обучения. Политика, ориентированная на расширение доступа, направлена на увеличение количества лет, которые дети проводят в школе. К ним относятся такие меры, как бесплатное начальное и среднее образование, строительство школ, автоматическое повышение в должности и другие меры, которые в первую очередь ориентированы на зачисление или достижение соответствующего образовательного уровня. Политика, ориентированная на улучшение качества обучения, направлена на увеличение объема знаний, получаемых детьми в каждом классе школы. Примерами такой политики являются постановка и измерение прогресса в сравнении с четкими целями обучения, корректировка обучения в соответствии с темпом обучения детей и поддержка эффективного обучения."
    }), "\n", _jsxs(_components.p, {
      children: ["Каждый ребенок должен иметь доступ к школе, и посещение им школы является необходимым первым шагом на пути к всеобщему обучению. Однако эти модели показывают, что дальнейшее ", _jsx(HighlightByIndex, {
        index: "2",
        children: "расширение доступа"
      }), " само по себе мало что даст для решения проблемы обучения. Напротив, можно получить большой потенциальный выигрыш за счет ", _jsx(HighlightByIndex, {
        index: "3",
        children: "увеличения объема обучения за год"
      }), ", чтобы соответствовать темпам стран с низким уровнем доходов и с уровнем доходов ниже среднего, показывающих более высокие результаты."]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TRAJECTORIES_SIMULATION_LMIC"
        })
      }), _jsx(ScrollySection, {
        id: "COMPARISON",
        children: _jsx(_components.p, {
          children: "Разница в результатах между странами с более низкими и более высокими показателями\nобусловлена как более широким доступом к школьному образованию, так и, в частности,\nпредоставлением детям возможности изучить больше в каждом классе."
        })
      }), _jsx(ScrollySection, {
        id: "FADED",
        children: _jsx(_components.p, {
          children: "Эти модели показывают траектории по возрасту. Они включают как школьников, так и детей,\nне посещающих школу. Поскольку дети, не посещающие школу, как правило, демонстрируют более низкую\nуспеваемость, эти траектории обучения более плоские, чем траектории по классам."
        })
      }), _jsx(ScrollySection, {
        id: "CURRENT",
        children: _jsxs(_components.p, {
          children: ["При усреднении результатов в пяти", " ", "\n", _jsx(HighlightByIndex, {
            index: "4",
            children: "странах с низким уровнем доходов и с уровнем доходов ниже среднего"
          }), " ", "\nс низкими показателями только 8 % 9-летних детей умеют читать на уровне, соответствующем\nвозрасту."]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_ACCESS",
        children: _jsxs(_components.p, {
          children: [_jsx(HighlightByIndex, {
            index: "2",
            children: "Моделирование доступа"
          }), " ", "\nприблизительно соответствует тому, что могло бы произойти, если бы все дети ходили в школу. Это делается\nпутем оценки того, что произошло бы, если бы все дети, которые никогда не посещали\nшколу или бросили ее, вместо этого достигли бы того же среднего класса и\nуровня обучения, что и их сверстники, посещающие школу. Согласно результатам моделирования, в тех же пяти\nстранах с низкими показателями это позволило бы увеличить\nколичество 9-летних детей, которые умеют читать, на 1 процентный пункт."]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_LEARNING",
        children: _jsxs(_components.p, {
          children: ["Если бы 9-летние дети в этих странах учились бы в том же классе, как и сейчас,\nно вместо этого", " ", "\n", _jsx(HighlightByIndex, {
            index: "3",
            children: "узнавали бы столько же за класс"
          }), ", сколько\nдети в пяти странах с самыми высокими показателями и низким уровнем доходов и с уровнем доходов ниже среднего,\nто 43 процента из них могли бы уметь читать, что составляет рост на\n35 процентных пунктов."]
        })
      }), _jsx(ScrollyStep, {
        id: "default"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "моделирование-политики-равенство",
      children: "Моделирование политики: равенство"
    }), "\n", _jsx(_components.p, {
      children: "Траектории обучения также являются мощным инструментом для понимания различий в обучении между группами внутри стран. Здесь мы сравниваем уровень обучения детей из богатых и бедных семей и моделируем влияние политики, направленной на сокращение неравенства между ними."
    }), "\n", _jsxs(_components.p, {
      children: ["В среднем по всем странам с низким уровнем доходов и с уровнем доходов ниже среднего, включенным в набор данных, дети из богатых семей (семейный достаток в верхних 20 процентах) ходят в школу больше и узнают больше в каждом классе, чем дети из бедных семей (семейный достаток в нижних 20 процентах). ", _jsx(HighlightByIndex, {
        index: "2",
        children: "Моделирование равного доступа"
      }), " показывает, что могло бы произойти, если бы дети из бедных семей получали такой же уровень образования, как и дети из богатых семей, в то время как ", _jsx(HighlightByIndex, {
        index: "3",
        children: "моделирование равного обучения"
      }), " показывает, что могло бы произойти, если бы дети из бедных семей узнавали столько же за учебный год, сколько и дети из богатых семей. В обоих сценариях, и особенно в моделировании с равным обучением, наблюдается уменьшение неравенства."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Однако даже дети из богатых семей не получают очень хорошего образования"
      }), ". Почти половина детей из богатых семей не способны овладеть базовыми навыками чтения, что ограничивает потенциальное влияние политики, ориентированной на обеспечение равенства. Моделирование равенства между мальчиками и девочками или детьми в городских и сельских районах дает еще меньшие результаты."]
    }), "\n", _jsxs(_components.p, {
      children: ["Для страны, которая хочет решить проблему низкого уровня обучения, вывод, полученный в результате применения политики, заключается в том, что устранение разрыва между группами внутри стран является лишь частью решения. ", _jsx(_components.strong, {
        children: "Не менее актуальной задачей является проведение системных изменений, которые улучшат обучение всех детей — из богатых и бедных семей, мальчиков и девочек, в городских и сельских районах – для достижения перехода от низкоэффективной к высокоэффективной системе."
      })]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TRAJECTORIES_SIMULATION_EQUALITY"
        })
      }), _jsx(ScrollySection, {
        id: "CURRENT",
        children: _jsxs(_components.p, {
          children: ["Дети из ", _jsx(HighlightByIndex, {
            index: "4",
            children: "бедных семей"
          }), " находятся\nна более низкой траектории обучения, чем дети из богатых семей. В среднем\nпо 23 странам с низким уровнем доходов и с уровнем доходов ниже среднего только 19 %\nдетей из бедных семей имеют базовые навыки чтения к 9 годам."]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_ACCESS",
        children: _jsxs(_components.p, {
          children: [_jsx(HighlightByIndex, {
            index: "2",
            children: "Первое моделирование"
          }), " показывает,\nчто могло бы произойти, если бы дети из бедных семей учились в школе столько, сколько и\nдети из богатых семей (с точки зрения уровня полученного образования в зависимости от возраста). В среднем\nпо 23 странам это повысило бы базовые навыки чтения только на 4\nпроцентных пункта в возрасте 9 лет."]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_LEARNING",
        children: _jsxs(_components.p, {
          children: [_jsx(HighlightByIndex, {
            index: "3",
            children: "Второе моделирование"
          }), " показывает,\nчто могло бы произойти, если дети из бедных семей сохраняли бы текущий\nуровень школьного образования (т. е. достигли того же класса, что и сейчас), но получали\nстолько же знаний за учебный год, сколько и дети из богатых семей. Это потенциально могло бы\nповысить базовые навыки чтения на 17 процентных пунктов в возрасте 9\nлет."]
        })
      }), _jsx(ScrollySection, {
        id: "COMPARISON",
        children: _jsx(_components.p, {
          children: "Если бы дети из бедных семей получали такой же уровень школьного образования и узнавали столько же за учебный год, сколько и\nдети из богатых семей (то есть если бы дети из бедных семей имели ту же траекторию, что и дети из богатых семей),\nбазовые навыки чтения у детей из бедных семей могли вырасти на 29\nпроцентных пункта в возрасте 9 лет."
        })
      }), _jsx(ScrollySection, {
        id: "COMPARISON_GROUP",
        children: _jsx(_components.p, {
          children: "Тем не менее почти половина детей все равно осталась бы без базовых\nнавыков чтения. Даже дети из богатых семей не получают хорошего\nобразования во многих странах."
        })
      }), _jsx(ScrollyStep, {
        id: "default"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "создавайте-свои-собственные-траектории-обучения-и-моделирование-политики",
      children: "Создавайте свои собственные траектории обучения и моделирование политики"
    }), "\n", _jsx(_components.p, {
      children: "Ниже приведен инструмент для создания собственных траекторий обучения и моделирования политики. Вы можете изучить данные из разных стран по базовым навыкам чтения и математики."
    }), "\n", _jsxs(_components.p, {
      children: ["Напоминаем, что навыки чтения оцениваются по тому, могут ли дети прочитать вслух простой рассказ из 70 слов и ответить на пять простых вопросов по тексту. Математические навыки оцениваются по четырем областям (распознавание чисел, различение чисел, простое сложение и числовые закономерности) с использованием 21 простого вопроса. Считается, что ребенок овладел этими базовыми навыками чтения и математики, если он правильно ответил на все вопросы. Обычно эти навыки соответствуют 2–3 классу, и они ниже минимального уровня владения навыками, определенного ", _jsx(_components.a, {
        href: "https://sdgs.un.org/goals/goal4",
        children: "глобальным показателем 4.1.1a ЦУР"
      }), "."]
    }), "\n", _jsxs(Explorer, {
      children: [_jsx(TrajectoriesTab, {
        children: _jsx(_components.p, {
          children: "Траектории обучения сильно различаются в зависимости от контекста. Этот инструмент позволяет вам\nстроить, сравнивать и экспортировать наиболее релевантные для вас траектории.\nВы можете визуализировать и сравнивать траектории разных стран или\nстроить и сравнивать траектории групп внутри одной страны."
        })
      }), _jsx(SimulationsTab, {
        children: _jsx(_components.p, {
          children: "Эти инструменты позволяют проводить моделирование политики и анализировать результаты для\nопределения приоритетов политики. Вы можете проводить моделирование политики на уровне\nстраны, чтобы оценить влияние достижения всеобщего школьного образования\nи достижения уровня обучения на класс в стране, с которой проводится сравнение. Вы можете\nтакже проводить моделирование политики для групп внутри страны, чтобы\nсмоделировать, каким было бы воздействие, если бы две группы населения имели одинаковые\nпоказатели уровня полученного образования и обучения в школе."
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "заключение",
      children: "Заключение"
    }), "\n", _jsx(_components.p, {
      children: "Траектории обучения показывают, как быстро дети приобретают базовые навыки обучения. Они являются важным инструментом, который можно использовать для повышения осведомленности общественности о низких результатах обучения и оказания помощи лицам, ответственным за разработку политики, в планировании дальнейших действий."
    }), "\n", _jsx(_components.h3, {
      id: "благодарность",
      children: "Благодарность"
    }), "\n", _jsxs(_components.p, {
      children: ["Содержание этой веб-страницы было создано в рамках ", _jsx(_components.a, {
        href: "http://riseprogramme.org/",
        children: "программы RISE (Исследования по совершенствованию систем образования)"
      }), " — крупномасштабной исследовательской программы по системам образования, поддерживаемой финансированием со стороны ", _jsx(_components.a, {
        href: "https://www.gov.uk/government/organisations/foreign-commonwealth-development-office",
        children: "Министерства иностранных дел, по делам Содружества и развития Соединенного Королевства (FCDO)"
      }), ", ", _jsx(_components.a, {
        href: "http://dfat.gov.au",
        children: "Министерства иностранных дел и торговли Австралии (DFAT)"
      }), " и ", _jsx(_components.a, {
        href: "https://www.gatesfoundation.org",
        children: "Фонда Билла и Мелинды Гейтс"
      }), ". Программа управляется и реализуется в рамках партнерства между ", _jsx(_components.a, {
        href: "https://www.opml.co.uk",
        children: "Oxford Policy Management"
      }), "и ", _jsx(_components.a, {
        href: "http://bsg.ox.ac.uk",
        children: "Школой государственного управления имени Блаватника при Оксфордском университете"
      }), "."]
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://riseprogramme.org/tools/learning-trajectories",
            children: "Ресурсы траекторий обучения — RISE"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://data.unicef.org/resources/are-children-really-learning-foundational-skills-report/",
            children: "Действительно ли дети учатся? Изучение основополагающих навыков в разгар кризиса обучения — ЮНИСЕФ 2022"
          })
        }), "\n", _jsx(_components.li, {
          children: "Специальный выпуск по образовательным профилям (открытый источник) – Международный журнал образовательного развития (IJED)](https://www.sciencedirect.com/journal/international-journal-of-educational-development/special-issue/1035CNWP9N3)"
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://mics.unicef.org/files?job=W1siZiIsIjIwMjAvMDUvMTIvMTgvMjUvNDUvNzAxLzIwXzA1XzA4X01JQ1NfR3VpZGVib29rX2NvbXByZXNzZWQucGRmIl1d&sha=6d386818d588d05c",
            children: "Как анализировать данные КОМП по образованию — ЮНИСЕФ"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://riseprogramme.org/publications/descriptive-learning-trajectories-and-policy-simulations-using-mics6-data",
            children: "Методология моделирования — RISE"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
